import React, { useState, useEffect } from "react";
import "../styles/data.scss"; // Import the styles
import GISHeader from "../components/gis/gisheader";

const datasetUrls = {
  Tanks: "/api/latesttanks",
  Bulkmeters: "/api/bulkmeters",
  Boreholes: "/api/boreholes",
  Weirs: "/api/weirs",
  Pipelines: "/api/pipelines",
  Offtakes: "/api/offtakes",
  ControlValves: "/api/controlvalves",
  TWorks: "/api/tworks",
};

const DataPage = () => {
  const [selectedDataset, setSelectedDataset] = useState("Tanks");
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await fetch(datasetUrls[selectedDataset]);
        if (!response.ok) throw new Error("Failed to fetch data");
        const data = await response.json();
        
        // setFilteredData(data);
      } catch (err) {
        setError(err.message);
        setFilteredData([]);
      }
      setLoading(false);
    };

    fetchData();
  }, [selectedDataset]);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const displayedData = filteredData.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  return (
    <div className="data-page">
      <GISHeader />
      <div className="data-content">
        {/* Search Bar with Select */}
        <div className="controlss">
          <div className="data-search-bar">
            <select
              value={selectedDataset}
              onChange={(e) => setSelectedDataset(e.target.value)}
              className="data-search-select"
            >
              {Object.keys(datasetUrls).map((key) => (
                <option key={key} value={key}>
                  {key}
                </option>
              ))}
            </select>

            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearch}
              className="data-search-input"
            />

            <button className="data-search-btn">🔍</button>
          </div>
        </div>

        {/* Loading & Error Messages */}
        {loading && <p className="loading">Loading data...</p>}
        {error && <p className="error">{error}</p>}

        {/* Data Table */}
        {!loading && !error && displayedData.length > 0 ? (
          <table className="data-table">
            <thead>
              <tr>
                {Object.keys(displayedData[0]).map((col) => (
                  <th key={col}>{col}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {displayedData.map((item, index) => (
                <tr key={index}>
                  {Object.values(item).map((value, idx) => (
                    <td key={idx}>{value}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          !loading && <p className="no-data">No data available.</p>
        )}
      </div>
    </div>
  );
};

export default DataPage;
